import React from 'react';

import { HowItWorks } from '../HowItWorks';
import { ReferHosts } from '../ReferHosts';
import { JoinHeading } from './JoinHeading';

export const JoinPage = () => {
  return (
    <>
      <JoinHeading />
      <HowItWorks />
      <ReferHosts />
    </>
  );
};
